import React, { useState, useEffect } from 'react';
import { getEmployees } from '../services/googleScriptServiceCORS';
import { isMobileDevice } from '../utils/deviceDetection';
import './LoginPage.css';

function LoginPage({ onLogin, onAdminLogin }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    // Check device type on mount
    const isMobile = isMobileDevice();
    const isDesktopDevice = !isMobile;
    console.log('[LoginPage] Device check - isMobile:', isMobile, 'isDesktop:', isDesktopDevice);
    setIsDesktop(isDesktopDevice);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Vui lòng nhập email');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setError('Email không hợp lệ');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // 1. Lấy danh sách nhân viên từ Google Sheets
      const employees = await getEmployees();
      
      // 2. Tìm nhân viên theo email
      const employee = employees.find(emp => 
        emp.email && emp.email.toLowerCase().trim() === email.trim().toLowerCase()
      );

      if (employee) {
        if (employee.status !== 'Đang làm việc') {
            setError('Nhân viên này đã nghỉ việc hoặc ngừng hoạt động');
        } else {
            // Login thành công
            onLogin(employee);
        }
      } else {
        setError('Email không tồn tại trong hệ thống');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Lỗi kết nối: ' + (err.message || 'Không thể kiểm tra email'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src="/logo.png" alt="FSI Logo" className="login-logo" />
          <h1>Chấm Công</h1>
          <p>Nhập email để bắt đầu</p>
        </div>

        {isDesktop && (
          <div className="desktop-warning-box">
            <div className="warning-icon-small">⚠️</div>
            <p className="warning-text">
              <strong>Ứng dụng chỉ dành cho điện thoại di động.</strong>
            </p>
            <p className="warning-hint">
              Vui lòng sử dụng điện thoại để chấm công. Quản trị viên có thể truy cập trang quản trị trên máy tính.
            </p>
          </div>
        )}

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <input
              type="email"
              placeholder="Email (Ví dụ: nhanvien@example.com)"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading || isDesktop}
              autoFocus={!isDesktop}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="btn-login" 
            disabled={loading || isDesktop}
            title={isDesktop ? 'Vui lòng sử dụng điện thoại để chấm công' : ''}
          >
            {loading ? 'Đang kiểm tra...' : 'Bắt Đầu Chấm Công'}
          </button>
        </form>

        <div className="login-footer">
          <button onClick={onAdminLogin} className="btn-admin-link">
            Quản trị viên
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
